import {useId,type ReactNode} from 'react';
import type {Deadline} from '../api';
import {AsyncState,type AsyncPhase} from '../components/AsyncState';
import {Icon,type IconName} from '../ui/Icon';
import {StatusBadge} from '../ui/Workspace';

const sources:Record<string,{label:string;icon:IconName}>={
  CONTRACT:{label:'Договор',icon:'contracts'},
  LICENSE:{label:'Лицензия',icon:'licenses'},
  EQUIPMENT:{label:'Оборудование',icon:'equipment'},
};
const dateFormatter=new Intl.DateTimeFormat('ru-RU',{day:'numeric',month:'short',year:'numeric',timeZone:'UTC'});
function dateLabel(value:string){
  const date=new Date(`${value}T00:00:00Z`);
  return Number.isNaN(date.getTime())?value:dateFormatter.format(date);
}

export function DeadlinePanel({items,filters,phase='ready',onRetry}:{items:Deadline[];filters?:ReactNode;phase?:AsyncPhase;onRetry?:()=>void}){
  const titleId=useId();
  return <section className="deadline-panel" aria-labelledby={titleId}>
    <div className="deadline-panel-heading"><div><p className="eyebrow">СРОКИ</p><h2 id={titleId}>Ближайшие и просроченные даты</h2></div>{phase==='ready'&&<span className="deadline-count">Всего: {items.length}</span>}</div>
    {filters&&<div className="deadline-filters">{filters}</div>}
    <AsyncState phase={phase} onRetry={onRetry}>{items.length===0?<p className="empty">Сроков по выбранным условиям нет</p>:<ul className="deadline-list">{items.map(item=>{
      const source=sources[item.sourceType]??{label:'Срок',icon:'calendar' as const};
      const title=item.sourceType==='CONTRACT'&&/^\d+$/.test(item.label)?`Договор № ${item.label}`:item.label;
      return <li className="deadline-row" key={`${item.sourceType}:${item.sourceId}:${item.date}`}>
        <span className="deadline-source-icon"><Icon name={source.icon} size={19}/></span>
        <div className="deadline-description"><strong>{title}</strong><span>{source.label} · {dateLabel(item.date)}</span></div>
        <StatusBadge tone={item.daysRemaining<0?'red':item.daysRemaining===0?'amber':'blue'}>{item.daysRemaining<0?`Просрочено на ${-item.daysRemaining} дн.`:item.daysRemaining===0?'Сегодня':`Через ${item.daysRemaining} дн.`}</StatusBadge>
      </li>;
    })}</ul>}</AsyncState>
  </section>;
}
